import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// Components
import { Preloader } from './components/Preloader';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import WorkDetailPage from './pages/WorkDetailPage';
import LabPage from './pages/LabPage';
import LabDetailPage from './pages/LabDetailPage';

function App() {
  const location = useLocation();

  return (
    <>
      {/* Preloader - shows on initial page load */}
      <Preloader />

      {/* Page Routes */}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/work" element={<Navigate to="/" replace />} />
          <Route path="/work/:slug" element={<WorkDetailPage />} />
          <Route path="/lab" element={<LabPage />} />
          <Route path="/lab/:slug" element={<LabDetailPage />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
